module.exports = __webpack_public_path__ + "img/late-tortoise.5edeba76.png";